// Strategy definitions
export const STRATEGIES = [
  {
    name: "Favorites Strategy",
    prompt: "How do you want favorites factored in to your playbook?",
    options: [
      "Choose all favorites",
      "Men's favorites only",
      "Women's favorites only",
      "Low elo favorites",
      "High elo favorites"
    ]
  },
  {
    name: "Big Favorites Strategy",
    prompt: "How big do a favorite's odds need to be for you to think they'll definitely win?",
    options: [
      "At least 1.05 (-2000)",
      "At least 1.25 (-400)",
      "At least 1.45 (-222)",
      "At least 1.65 (-154)",
      "At least 1.85 (-118)"
    ]
  },
  {
    name: "Small Underdogs Strategy",
    prompt: "How small do an underdog's odds need to be for you to think they have a chance?",
    options: [
      "At most 2.05 (+105)",
      "At most 2.25 (+125)",
      "At most 2.45 (+145)",
      "At most 2.65 (+165)",
      "At most 2.85 (+185)"
    ]
  },
  {
    name: "Age Difference Strategy",
    prompt: "How much younger does a fighter need to be for you to think that they'll win?",
    options: [
      "At least 1 year younger",
      "At least 3 years younger",
      "At least 5 years younger"
    ]
  },
  {
    name: "Height Difference Strategy",
    prompt: "How much taller does a fighter need to be for you to think that they'll win?",
    options: [
      "At least 1 inch",
      "At least 3 inches",
      "At least 5 inches"
    ]
  },
  {
    name: "Reach Difference Strategy",
    prompt: "How much longer does a fighter's reach need to be for you to think that they'll win?",
    options: [
      "At least 1 inch",
      "At least 3 inches",
      "At least 5 inches"
    ]
  },
  {
    name: "Striker v Grappler Strategy",
    prompt: "Do you prefer fighters who are better strikers or better grapplers?",
    options: [
      "Better strikers",
      "Better grapplers"
    ]
  },
  {
    name: "Win Rate Strategy",
    prompt: "Which of these win rates is most indicative of a fighter that's going to win?",
    options: [
      "Fighters that win more overall",
      "Fighters that win more in the UFC",
      "Fighters with a higher recent win rate",
      "Fighters that win more by decision",
      "Fighters that win more by finish"
    ]
  },
  {
    name: "Biggest Favorites Parlay Strategy",
    prompt: "You're parlaying the biggest favorites on a card. How many fighters do you want in the parlay?",
    options: [
      "1 leg",
      "2 legs",
      "3 legs",
      "4 legs",
      "5 legs"
    ]
  },
  {
    name: "Capper Strategy",
    prompt: "Our AI emulates successful cappers. What capper profile do you want in your parlay?",
    options: [
      "Distance Decider",
      "Odds Observer",
      "Takedown Tracker",
      "Recklessness Reviewer",
      "Clinch Counter"
    ]
  }
];

// Strategy to column name mappings
export const STRATEGY_MAPPINGS = {
  "Favorites Strategy": {
    "Choose all favorites": "strategy_favorites_event_return_actual_cumsum",
    "Men's favorites only": "strategy_male_favorites_event_return_actual_cumsum",
    "Women's favorites only": "strategy_female_favorites_event_return_actual_cumsum",
    "Low elo favorites": "strategy_2000_max_elo_pick_favorite_event_return_actual_cumsum",
    "High elo favorites": "strategy_2000_min_elo_pick_favorite_event_return_actual_cumsum"
  },
  "Big Favorites Strategy": {
    "At least 1.05 (-2000)": "strategy_big_favorites_thresh_1.05_event_return_actual_cumsum",
    "At least 1.25 (-400)": "strategy_big_favorites_thresh_1.25_event_return_actual_cumsum",
    "At least 1.45 (-222)": "strategy_big_favorites_thresh_1.45_event_return_actual_cumsum",
    "At least 1.65 (-154)": "strategy_big_favorites_thresh_1.65_event_return_actual_cumsum",
    "At least 1.85 (-118)": "strategy_big_favorites_thresh_1.85_event_return_actual_cumsum"
  },
  "Small Underdogs Strategy": {
    "At most 2.05 (+105)": "strategy_small_underdogs_thresh_2.05_event_return_actual_cumsum",
    "At most 2.25 (+125)": "strategy_small_underdogs_thresh_2.25_event_return_actual_cumsum",
    "At most 2.45 (+145)": "strategy_small_underdogs_thresh_2.45_event_return_actual_cumsum",
    "At most 2.65 (+165)": "strategy_small_underdogs_thresh_2.65_event_return_actual_cumsum",
    "At most 2.85 (+185)": "strategy_small_underdogs_thresh_2.85_event_return_actual_cumsum"
  },
  "Age Difference Strategy": {
    "At least 1 year younger": "strategy_age_diff_1_years_event_return_actual_cumsum",
    "At least 3 years younger": "strategy_age_diff_3_years_event_return_actual_cumsum",
    "At least 5 years younger": "strategy_age_diff_5_years_event_return_actual_cumsum"
  },
  "Height Difference Strategy": {
    "At least 1 inch": "strategy_height_diff_1_inches_event_return_actual_cumsum",
    "At least 3 inches": "strategy_height_diff_3_inches_event_return_actual_cumsum",
    "At least 5 inches": "strategy_height_diff_5_inches_event_return_actual_cumsum"
  },
  "Reach Difference Strategy": {
    "At least 1 inch": "strategy_reach_diff_1_inches_event_return_actual_cumsum",
    "At least 3 inches": "strategy_reach_diff_3_inches_event_return_actual_cumsum",
    "At least 5 inches": "strategy_reach_diff_5_inches_event_return_actual_cumsum"
  },
  "Striker v Grappler Strategy": {
    "Better strikers": "strategy_higher_sig_str_hit_3_min_fights_event_return_actual_cumsum",
    "Better grapplers": "strategy_higher_takedown_hit_3_min_fights_event_return_actual_cumsum"
  },
  "Win Rate Strategy": {
    "Fighters that win more overall": "strategy_higher_all_record_win_rate_3_min_fights_event_return_actual_cumsum",
    "Fighters that win more in the UFC": "strategy_ufc_win_rate_1_min_fights_event_return_actual_cumsum",
    "Fighters with a higher recent win rate": "strategy_recent_win_rate_3_min_fights_event_return_actual_cumsum",
    "Fighters that win more by decision": "strategy_higher_decision_specific_win_rate_1_min_decisions_event_return_actual_cumsum",
    "Fighters that win more by finish": "strategy_higher_finish_specific_win_rate_1_min_finishes_event_return_actual_cumsum"
  },
  "Biggest Favorites Parlay Strategy": {
    "1 leg": "strategy_1_leg_parlay_biggest_favorites_event_return_actual_cumsum",
    "2 legs": "strategy_2_leg_parlay_biggest_favorites_event_return_actual_cumsum",
    "3 legs": "strategy_3_leg_parlay_biggest_favorites_event_return_actual_cumsum",
    "4 legs": "strategy_4_leg_parlay_biggest_favorites_event_return_actual_cumsum",
    "5 legs": "strategy_5_leg_parlay_biggest_favorites_event_return_actual_cumsum"
  },
  "Capper Strategy": {
    "Distance Decider": "strategy_bet_mma_picks_id_140016_event_return_actual_cumsum",
    "Odds Observer": "strategy_bet_mma_picks_id_130543_event_return_actual_cumsum",
    "Takedown Tracker": "strategy_bet_mma_picks_id_131163_event_return_actual_cumsum",
    "Recklessness Reviewer": "strategy_bet_mma_picks_id_139213_event_return_actual_cumsum",
    "Clinch Counter": "strategy_bet_mma_picks_id_137664_event_return_actual_cumsum"
  }
}; 